module.exports = __webpack_public_path__ + "img/marker-green.9f531961.svg";